import { BFFBadRequest } from '../../interfaces/BFFBadRequest';

export default function mapFormErrors(r: BFFBadRequest, controlErrorMapping: { [name: string]: string }, genericErrorMessage: string, unexpectedErrorMessage: string): { [key: string]: string } {
  if (!r?.data?.errors) {
    return {
      validationMessage: unexpectedErrorMessage,
    };
  }
  const unmappedErrors = r.data.errors.filter((x) => controlErrorMapping[x.field] === undefined);
  if (unmappedErrors.length === 0) {
    return {
      validationMessage: genericErrorMessage,
    };
  }
  return Object.fromEntries(new Map(unmappedErrors.map((x, i) => [
    `validationMessage${i + 1}`, x.message,
  ])));
}
